import { DOCUMENT } from '@angular/common';
import { DestroyRef, inject, Injectable, signal } from '@angular/core';

interface FilterPanelHandle {
	closePanel(): void;
	containsTarget(target: EventTarget | null): boolean;
}

@Injectable({ providedIn: 'root' })
export class DatabaseFilterPanelRegistry {
	private readonly document = inject(DOCUMENT);
	private readonly activePanel = signal<FilterPanelHandle | null>(null);
	private readonly onDocumentClick = (event: MouseEvent) => {
		const view = this.document.defaultView;
		const target = event.target;
		if (!view || !(target instanceof view.Element)) return;

		const active = this.activePanel();
		if (active && !active.containsTarget(target)) {
			active.closePanel();
		}
	};

	public constructor() {
		this.document.addEventListener('click', this.onDocumentClick, true);
		inject(DestroyRef).onDestroy(() => this.document.removeEventListener('click', this.onDocumentClick, true));
	}

	public register(panel: FilterPanelHandle) {
		const current = this.activePanel();
		if (current && current !== panel) {
			current.closePanel();
		}

		this.activePanel.set(panel);
	}

	public closeActive() {
		this.activePanel()?.closePanel();
	}

	public unregister(panel: FilterPanelHandle) {
		if (this.activePanel() === panel) {
			this.activePanel.set(null);
		}
	}
}
